import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/orders/payment-methods/global'

export const ORDERS_PAYMENT_METHODS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
